export function ChatFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.586 16.914a2 2 0 01-.375-2.308 12.065 12.065 0 00.657-1.576A5.8 5.8 0 012 10C2 7.806 3.25 6.008 4.888 4.837 6.53 3.663 8.698 3 11 3s4.47.663 6.112 1.837C18.752 6.007 20 7.806 20 10c0 2.194-1.248 3.992-2.888 5.163C15.47 16.337 13.302 17 11 17c-1.438 0-2.815-.258-4.043-.732-.3.132-.679.323-1.227.6-.243.123-.518.262-.836.42a2 2 0 01-2.308-.374z"
        clipRule="evenodd"
      ></path>
      <path
        fill="currentColor"
        d="M20.958 9.881a8.344 8.344 0 01-.966 3.13c.005.083.008.167.008.25 0 .838-.272 1.625-.75 2.308a.423.423 0 00-.062.2c-.06.575.438 1.899.812 2.731l-.652-.365c-1.03-.579-1.593-.894-1.944-.892a.432.432 0 00-.195.044 7.152 7.152 0 01-3.209.737c-.389 0-.769-.03-1.137-.085a11.085 11.085 0 01-4.976-.29c1.546 1.514 3.842 2.375 6.113 2.375a9.27 9.27 0 003.447-.653c.128.067.283.151.476.258l.447.25.054.031c.184.104.386.217.605.338a2 2 0 002.795-2.569 12.246 12.246 0 01-.575-1.541A5.924 5.924 0 0022 13.262a5.922 5.922 0 00-1.042-3.38z"
      ></path>
    </svg>
  );
}
